import { DEAL_RENT_MENU_LINK } from '../constants/config/experiments';
import { IExperiment, TDealRentLinkExperiment } from '../types/experiments';

interface IGetDealRentLinkExperimentParams {
  experiments: IExperiment[];
  regionId: number;
  dealRegions: number[];
}

export function getDealRentLinkExperiment(params: IGetDealRentLinkExperimentParams): TDealRentLinkExperiment {
  const { experiments, regionId, dealRegions } = params;

  const isTargetRegion = dealRegions.includes(regionId);
  const experiment = experiments.find(({ experimentName }) => experimentName === DEAL_RENT_MENU_LINK);
  const group = experiment?.groupName;

  if (!isTargetRegion || !group) {
    return 'off';
  }

  switch (group) {
    case 'A':
      return 'dealRent';

    case 'B':
      return 'cianRent';

    default:
      return 'off';
  }
}
